exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.v-offset {\n  margin: 0 auto;\n  max-width: calc(100% - 32px);\n  position: relative;\n  z-index: 1;\n}\n.v-offset--full-width {\n  max-width: 100%;\n}\n", ""]);

// exports
